import { Route } from '@angular/router';
import { AuthenticationLoginComponent } from './lib/feature/authentication-login/authentication-login.component';
import { AuthenticationCallbackComponent } from './lib/feature/authentication-callback/authentication-callback.component';
import { AuthenticationLogoutComponent } from './lib/feature/authentication-logout/authentication-logout.component';

export const auth0Routes: Route[] = [
    {
        path: 'callback',
        component: AuthenticationCallbackComponent,
    },
    {
        path: 'login',
        component: AuthenticationLoginComponent,
    },
    {
        path: 'logout',
        component: AuthenticationLogoutComponent,
    },
];
